// @flow
/* eslint-disable jsx-a11y/alt-text */

// $FlowFixMe
import React, { useState } from 'react';

import type { Metadata } from 'Common/cast/types';
import { MetadataViewerStyles as styles } from './styles';

type Props = {|
  mode: 'full_poster' | 'mini_info',
  metadata: Metadata,
|};

const MetadataViewer = ({ mode, metadata: { posterUrl, title = '', subtitle } }: Props) => {
  const [posterOpacity, setPosterOpacity] = useState(0);

  const onLoad = () => setPosterOpacity(1);

  if (mode === 'full_poster')
    return (
      <div style={styles.posterContainer(posterOpacity)}>
        <img src={posterUrl} onLoad={onLoad} style={styles.poster} />
        <p style={styles.titleFull}>{title}</p>
        {title !== subtitle && <p style={styles.subtitleFull}>{subtitle}</p>}
      </div>
    );

  if (mode === 'mini_info') {
    const renderTitle = !posterUrl || posterOpacity === 1;

    return (
      <div style={styles.miniInfoContainer(title, subtitle)}>
        {posterUrl ? <img src={posterUrl} style={styles.miniPoster} onLoad={onLoad} /> : null}

        {renderTitle && (
          <div>
            <p style={styles.title}>{title}</p>
            {title !== subtitle && <p style={styles.subtitle}>{subtitle}</p>}
          </div>
        )}
      </div>
    );
  }

  (mode: 'empty'); // eslint-disable-line no-unused-expressions
  return null;
};

export { MetadataViewer };
